import { useActiveRegistrar } from './use-active-registrar';

/**
 * Owner decision D5 (docs/decizii-paritate-wireframe-2026-09-05.md): the screens
 * whose wireframe writes the Registrar in prose name it, they do not print its
 * IDNO. `registrarNames` is index-aligned with `registrarScope`.
 *
 * Which of them is named is owner ruling 2026-09-06 (finding D-14): the one the
 * session is WORKING ON, not the first it holds. These ledes sit above registers
 * that `activeRegistrarScope` now narrows on the server, so a lede naming
 * anything else would title the wrong register.
 *
 * An IDNO the catalog does not know keeps its place in the array as an empty
 * string, deliberately, so the alignment survives it. The fallback is therefore
 * that IDNO and never a blank: "I do not know this Registrar" and "this
 * Registrar is withdrawn" are different sentences and the reader needs the
 * second one. Same discipline as SidebarAccount.tsx.
 *
 * Empty only while the session query is in flight, or for a role with no
 * Registrar of its own. Both cases mean the head carries no lede at all, which
 * is what Stocuri.tsx:218 draws for the System Administrator.
 */
export function useSessionRegistrarName(): string {
  return useActiveRegistrar().name;
}
